import { network } from './network';
import { CategoryMinutesRequest, CategoryMinutesResponse } from '@utils/categoryTime';

const basePath = (semesterId: number, courseId: number) => `/semesters/${semesterId}/courses/${courseId}/task-categories`;

// A category's time, and with applyToUnfinished the whole estimate of each of its tasks still to do.
const setCategoryMinutes = (semesterId: number, courseId: number, categoryId: number, request: CategoryMinutesRequest) =>
  network.put<CategoryMinutesResponse>(`${basePath(semesterId, courseId)}/${categoryId}/minutes`, request);

// How many tasks each of the course's categories has still to do, readings left out, by category id; with
// onlyUnestimated, only those with no time yet.
const unfinishedCounts = (semesterId: number, courseId: number, onlyUnestimated = false) =>
  network.get<Record<number, number>>(
    `${basePath(semesterId, courseId)}/unfinished-counts`,
    onlyUnestimated ? { onlyUnestimated: true } : undefined
  );

export const categoryTimeApi = { setCategoryMinutes, unfinishedCounts };
